import { Box, Theme } from "@mui/material";
import { TFunction } from "i18next";

import { getStyles } from "./utils/styles";

export function TooltipEventRow({
  event,
  eventPast,
  t,
  theme,
}: {
  event?: string | null;
  eventPast?: string | null;
  t: TFunction;
  theme: Theme;
}) {
  if (!event && !eventPast) return null;

  const styles = getStyles(theme);

  return (
    <Box style={styles.popupRowEvent}>
      <Box style={styles.popupCol}>
        <Box style={styles.textPrimary}>{t("Event")}</Box>
      </Box>

      <Box style={styles.popupColRight}>
        <Box style={styles.textPrimaryLargeBold}>{event ?? ""}</Box>
      </Box>

      <Box style={styles.popupColLeft}>
        <Box style={styles.textSecondary}>{eventPast ?? ""}</Box>
      </Box>
    </Box>
  );
}
